import { Workflow, BookOpen, Settings, HelpCircle, Plug, Database, ExternalLink } from 'lucide-react';

interface SidebarProps {
  activeSection: 'flows' | 'knowledge' | 'indices' | 'services' | 'help';
  onSectionChange: (section: 'flows' | 'knowledge' | 'indices' | 'services' | 'help') => void;
  onSettingsClick?: () => void;  // Handler speciale per aprire il pannello impostazioni
}

export default function Sidebar({ activeSection, onSectionChange, onSettingsClick }: SidebarProps) {
  const sections = [
    { id: 'flows', icon: Workflow, label: 'Flussi', color: 'text-purple-600' },
    { id: 'knowledge', icon: BookOpen, label: 'Knowledge Base', color: 'text-blue-600' },
    { id: 'indices', icon: Database, label: 'Gestione Indici', color: 'text-orange-600' },
    { id: 'services', icon: Plug, label: 'Servizi / API', color: 'text-teal-600' },
    { id: 'settings', icon: Settings, label: 'Impostazioni', color: 'text-gray-600' },
    { id: 'help', icon: HelpCircle, label: 'Aiuto', color: 'text-green-600' },
  ];

  return (
    <div className="w-16 bg-gray-900 flex flex-col items-center py-4 space-y-2 border-r border-gray-700 relative">
      {sections.map((section) => {
        const Icon = section.icon;
        const isActive = activeSection === section.id;
        
        return (
          <button
            key={section.id}
            onClick={() => {
              // Se è "settings" e c'è handler dedicato, usalo SOLO
              if (section.id === 'settings' && onSettingsClick) {
                onSettingsClick();
                // NON cambiare activeSection per settings
              } else {
                onSectionChange(section.id as any);
              }
            }}
            className={`
              w-12 h-12 rounded-lg flex items-center justify-center
              transition-all duration-200
              ${isActive 
                ? 'bg-purple-600 text-white shadow-lg scale-110' 
                : 'bg-gray-800 text-gray-400 hover:bg-gray-700 hover:text-white hover:scale-105'
              }
            `}
            title={section.label}
          >
            <Icon className="w-6 h-6" />
          </button>
        );
      })}
      
      {/* Spacer per spingere elementi in basso */}
      <div className="flex-1" />
      
      {/* Vai a OYSTAR */}
      <a
        href="https://oystar.ai"
        target="_blank"
        rel="noopener noreferrer"
        className="w-12 h-12 rounded-lg flex items-center justify-center bg-gradient-to-br from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white transition-all duration-200 hover:scale-105 shadow-lg"
        title="Vai a OYSTAR"
      >
        <ExternalLink className="w-5 h-5" />
      </a>
      
      {/* Indicatore versione - visibile in basso */}
      <div className="absolute bottom-2 left-0 right-0 text-center">
        <span className="text-[10px] font-mono bg-gray-800 text-green-400 px-2 py-0.5 rounded">
          v1.261
        </span>
      </div>
    </div>
  );
}

